(() => {
var $d3c1734dacb01657$exports = {};
// shim for using process in browser
var $d3c1734dacb01657$var$process = $d3c1734dacb01657$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};


var $0eec1a9a99f714de$var$s, $0eec1a9a99f714de$var$r, $0eec1a9a99f714de$var$w = typeof fetch == "function", $0eec1a9a99f714de$var$v = typeof window < "u", $0eec1a9a99f714de$var$d = typeof chrome < "u" && !!chrome.runtime?.id, $0eec1a9a99f714de$var$l = $0eec1a9a99f714de$var$f(), $0eec1a9a99f714de$var$p = new Date, $0eec1a9a99f714de$var$c = {
    US: "https://us.aptabase.com",
    EU: "https://eu.aptabase.com",
    DEV: "https://localhost:3000",
    SH: ""
};
function $0eec1a9a99f714de$var$u(e) {
    let n = new Date, t = n.getTime() - $0eec1a9a99f714de$var$p.getTime();
    return Math.floor(t / 1e3) > e && ($0eec1a9a99f714de$var$l = $0eec1a9a99f714de$var$f()), $0eec1a9a99f714de$var$p = n, $0eec1a9a99f714de$var$l;
}
function $0eec1a9a99f714de$var$f() {
    let e = Math.floor(Date.now() / 1e3).toString(), n = Math.floor(Math.random() * 1e8).toString().padStart(8, "0");
    return e + n;
}
function $0eec1a9a99f714de$var$g(e) {
    let n = e.split("-");
    return n.length !== 3 || $0eec1a9a99f714de$var$c[n[1]] === void 0 ? (console.warn(`The Aptabase App Key "${e}" is invalid. Tracking will be disabled.`), !1) : !0;
}
function $0eec1a9a99f714de$var$b(e, n) {
    let t = e.split("-")[1];
    if (t === "SH") {
        if (!n?.host) {
            console.warn("Host parameter must be defined when using Self-Hosted App Key. Tracking will be disabled.");
            return;
        }
        return `${n.host}/api/v0/event`;
    }
    return `${n?.host ?? $0eec1a9a99f714de$var$c[t]}/api/v0/event`;
}
async function $0eec1a9a99f714de$var$m(e) {
    if (!$0eec1a9a99f714de$var$w && !$0eec1a9a99f714de$var$d) {
        console.warn(`Aptabase: trackEvent requires fetch api. Event "${e.eventName}" will be discarded.`);
        return;
    }
    if (!e.appKey) {
        console.warn(`Aptabase: init must be called before trackEvent. Event "${e.eventName}" will be discarded.`);
        return;
    }
    let n = {};
    !$0eec1a9a99f714de$var$v && !$0eec1a9a99f714de$var$d && (n = {
        "User-Agent": $0eec1a9a99f714de$var$A()
    });
    try {
        let t = await fetch(e.apiUrl, {
            method: "POST",
            headers: {
                ...n,
                "Content-Type": "application/json",
                "App-Key": e.appKey
            },
            credentials: "omit",
            body: JSON.stringify({
                timestamp: new Date().toISOString(),
                sessionId: e.sessionId,
                eventName: e.eventName,
                systemProps: {
                    locale: e.locale ?? $0eec1a9a99f714de$var$y(),
                    isDebug: e.isDebug ?? $0eec1a9a99f714de$var$S(),
                    appVersion: e.appVersion ?? "",
                    sdkVersion: e.sdkVersion
                },
                props: e.props
            })
        });
        if (t.status >= 300) {
            let i = await t.text();
            console.warn(`Failed to send event "${e.eventName}": ${t.status} ${i}`);
        }
    } catch (t) {
        console.warn(`Failed to send event "${e.eventName}"`), console.warn(t);
    }
}
function $0eec1a9a99f714de$var$y() {
    if ($0eec1a9a99f714de$var$s) return $0eec1a9a99f714de$var$s;
    if (!(typeof navigator > "u")) return navigator.languages.length > 0 ? $0eec1a9a99f714de$var$s = navigator.languages[0] : $0eec1a9a99f714de$var$s = navigator.language, $0eec1a9a99f714de$var$s;
}
function $0eec1a9a99f714de$var$S() {
    return $0eec1a9a99f714de$var$r !== void 0 ? $0eec1a9a99f714de$var$r : typeof location > "u" ? ($0eec1a9a99f714de$var$r = !1, $0eec1a9a99f714de$var$r) : ($0eec1a9a99f714de$var$r = location.hostname === "localhost", $0eec1a9a99f714de$var$r);
}
function $0eec1a9a99f714de$var$A() {
    let e = "Unknown";
    return $d3c1734dacb01657$exports?.platform && (e = $0eec1a9a99f714de$var$I($d3c1734dacb01657$exports.platform)), `Mozilla/5.0 (${e}) Not-A-Browser`;
}
function $0eec1a9a99f714de$var$I(e) {
    switch(e){
        case "darwin":
            return "Macintosh";
        case "win32":
            return "Windows";
        case "linux":
            return "Linux";
        case "android":
            return "Android";
        default:
            return e;
    }
}
var $0eec1a9a99f714de$var$E = 3600, $0eec1a9a99f714de$var$x = "aptabase-web@0.5.0", $0eec1a9a99f714de$var$h = "", $0eec1a9a99f714de$var$o, $0eec1a9a99f714de$var$a;
function $0eec1a9a99f714de$export$2cd8252107eb640b(e, n) {
    $0eec1a9a99f714de$var$g(e) && ($0eec1a9a99f714de$var$o = n?.apiUrl ?? $0eec1a9a99f714de$var$b(e, n), $0eec1a9a99f714de$var$h = e, $0eec1a9a99f714de$var$a = n);
}
async function $0eec1a9a99f714de$export$73d0a139caca1fee(e, n) {
    if (!$0eec1a9a99f714de$var$o) return;
    let t = $0eec1a9a99f714de$var$u($0eec1a9a99f714de$var$E);
    await $0eec1a9a99f714de$var$m({
        apiUrl: $0eec1a9a99f714de$var$o,
        sessionId: t,
        appKey: $0eec1a9a99f714de$var$h,
        isDebug: $0eec1a9a99f714de$var$a?.isDebug,
        appVersion: $0eec1a9a99f714de$var$a?.appVersion,
        sdkVersion: $0eec1a9a99f714de$var$x,
        eventName: e,
        props: n
    });
}


(0, $0eec1a9a99f714de$export$2cd8252107eb640b)('A-SH-8192575251', {
    host: 'https://mproxy.godcaster.app',
    isDebug: false,
    appVersion: '1.0s'
});
window.metricsEvent = (0, $0eec1a9a99f714de$export$73d0a139caca1fee);

})();
//# sourceMappingURL=index.js.map
